<template>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <component-header
      title="User Management"
      @search-query="(val) => (filter = val)"
      :isLoading="loading"
      @reload-data="getSubtanentList"
      :hasReload="true"
      @create-press="$router.push({ path: '/user/create' })"
      :hasback="true"
      @back-press="goToViewPage"
    />
    <b-card class="card-wrap" border-variant="info">
      <div>
        <b-table
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive="sm"
          :items="tenantSubAdmins"
          :fields="tenantColumns"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          thead-class="header"
          show-empty
          :busy="loading"
          @filtered="onFilter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="status" slot-scope="data">
            <div class="table-row">{{ data.item.status || "ACTIVE" }}</div>
          </template>
          <template slot="action" slot-scope="data">
            <b-row>
              <!-- <b-col md="2"></b-col> -->
              <b-col md="4">
                <b-button size="sm" variant="primary" @click="viewUser(data.item)">
                  <i class="fa fa-eye"></i>
                </b-button>
              </b-col>
              <b-col md="4">
                <b-button size="sm" variant="primary" @click="editUser(data.item)">
                  <i class="fa fa-pencil edit"></i>
                </b-button>
              </b-col>
              <b-col md="4">
                <b-button
                  size="sm"
                  class="circularIcon"
                  @click="deleteUser(data.item)"
                  variant="danger"
                >
                  <i class="fa fa-trash"></i>
                </b-button>
              </b-col>
            </b-row>
          </template>
        </b-table>
      </div>
      <div style="float: right">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="filterCount"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentHeader";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
export default {
  name: "userlist",
  components: {
    ComponentHeader,
    loader,
  },
  data() {
    return {
      filterCount: 0,
      loading: false,
      perPage: 10,
      currentPage: 1,
      filter: "",
      loading: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      context: "Add",
      sortBy: "createdAt",
      sortDesc: true,
      tenantColumns: [
        {
          key: "fullName",
          label: "Name",
          sortable: true,
        },
        {
          key: "city",
        },
        {
          key: "email",
        },
        {
          key: "phone",
        },
        {
          key: "status",
        },
        {
          key: "category",
        },
        {
          key: "action",
        },
      ],
      status: "ACTIVE",
    };
  },
  computed: {
    tenantSubAdmins() {
      let data = this.$store.getters["tenant/GetTenantSubAdminList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj._id,
            city: obj.address.city,
            state: obj.address.state,
            country: obj.address.country,
            zip: obj.address.zip,
            userName: obj.authentication.userName,
            email: obj.authentication.email,
            phone: obj.authentication.phone,
            fullName: `${obj.name.first} ${obj.name.last}`,
            password: "",
            status: obj.status,
            orgAccessLevel: obj.authorization.orgAccess.orgAccessLevel,
            category: obj.authorization.category,
            value: obj.experience ? obj.experience.value : "",
            uom: obj.experience ? obj.experience.uom : "",
            createdAt: obj.createdAt,
            ...obj,
          };
          tenantList.push(arrayObj);
        });
        return tenantList;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    viewUser(data) {
      this.$router.push({ name: "ViewUser", params: { id: data._id, userData: data } });
    },
    goToViewPage() {
      if (this.$route.fullPath == "/user") {
        this.$router.push({
          name: "Home",
        });
      } else {
        this.$router.push({
          name: "PartnerView",
          params: { id: this.$route.params.id, parentId: this.$route.params.parentId },
        });
      }
    },
    editUser(data) {
      if (data.status == "PENDING") {
        this.$swal({
          title: "Your Approval is Pending",
          text: "Get your Approval Done From Distributor",
          type: "warning",
        });
      } else {
        this.$router.push({ name: "EditUser", params: { id: data._id, userData: data } });
      }
    },
    async deleteUser(data) {
      await this.$swal({
        title: "Are you sure?",
        text: "You can't revert this action!!",
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store.dispatch("tenant/deleteUser", data._id).then((result) => {
            this.$toasted.success("User Deleted Successfully");
            this.$store.dispatch("tenant/fetchTenantSubAdminList").catch((error) => {
              this.$toasted.error(error.message);
            });
          });
          this.isLoading = false;
        }
      });
    },
    async getSubtanentList() {
      this.loading = true;
      await this.$store
        .dispatch("tenant/fetchTenantSubAdminList")
        .then((data) => {
          if (data.message) {
            this.$toasted.error(data.message);
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  async mounted() {
    const tenantList = this.$store.getters["tenant/GetTenantSubAdminList"];
    this.getSubtanentList();
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
